/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2025-01-11 22:26:26
 **/
/* eslint-disable @typescript-eslint/no-explicit-any */

import { DBSchema, IDBPDatabase, openDB } from "idb";

interface PersistenceDB extends DBSchema {
	properties: {
		key: string;
		value: any;
	};
}

export default class PersistenceDatabase {
	static #instance: PersistenceDatabase | null = null;
	public static get instance() {
		if (!PersistenceDatabase.#instance) {
			PersistenceDatabase.#instance = new PersistenceDatabase();
		}
		return PersistenceDatabase.#instance;
	}

	private _db: Promise<IDBPDatabase<PersistenceDB>> | null = null;

	private constructor() {}

	public get db() {
		if (!this._db) {
			throw Error("Database is not ready");
		}
		return this._db;
	}

	public initialize() {
		return new Promise<boolean>((resolve) => {
			if (!this._db) {
				this._db = openDB<PersistenceDB>("rsupport", 1, {
					upgrade(db, oldVersion) {
						if (oldVersion === 1 || oldVersion === 2) {
							db.deleteObjectStore("properties");
						}

						db.createObjectStore("properties");
					}
				});
			}
			resolve(!!this._db);
		});
	}
}
